// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ExternalLinkIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ExternalLinkIcon" ref={forwardedRef} {...props}>
      <path d="M17 3v6h-1.5V5.621l-4.44 4.44L10 9l4.5-4.5H11V3z" />
      <path d="M8 3H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4h-1.5v3.5h-11v-11H8z" />
    </SvgIcon>
  );
});

/**
 * Use when linking to any external resource (i.e., outside the current tenant evironment
 * @public
 */
export const ExternalLinkIcon = /* @__PURE__ */ Object.assign(
  ExternalLinkIconComponent,
  { displayName: 'ExternalLinkIcon' },
);
